import {
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CallMadeIcon, { InfoIcon } from "components/common/CallMadeIcon";
import ChangeSelectPart from "components/home/ChangeSelectPart";
import SmartTypeInfo from "components/home/SmartTypeInfo";
import RequestStartupTalentForm from "components/smart-visa-extension/RequestTalentForm";
import RequestTalentInfo from "components/smart-visa-extension/RequestTalentInfo";
import { SMART_NAME_ALIAS, SMART_TYPE } from "libs/constant/smartForm";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import { CANCEL_STEP, STATUS_REPORT_STEP } from "libs/constant/VisaStep";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setStep } from "redux/modules/cancelVisaSlice";
import { setStep as setStepStatusReport } from "redux/modules/statusReportSlice";
import {
  setHomeTab,
  setIsExtension,
  setSmartFormStep
} from "redux/modules/uiSlice";
import {
  checkRequestSmartForm,
  checkRequestSmartFormSlice,
  documentRequiredSlice,
  extensionSlice,
  getDocumentRequired,
  getExtension,
  selectCheckRequestSmartForm,
  selectDocumentRequired,
  selectSmartFormExtension
} from "redux/modules/visaForm";
import VisaFormService from "services/VisaFormService";
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
  },
  card: {
    display: "flex",
    // minWidth: 309,
    // height: 170,
    height: 250,
    borderRadius: 17,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    marginTop: theme.spacing(4),
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
    },
    color: "#fff",
    flexDirection: "column",
  },
  body: {
    opacity: 0.75,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    // flex: 1,
    marginTop: theme.spacing(1),
    // backgroundColor: "pink",
  },
  wrapIcon: {
    display: "flex",
    flex: 1,
    alignItems: "flex-end",
  },
  wrapType: {
    cursor: "pointer",
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
  },
}));

function StatusCard({ title, subTitle, discription, color, type, onClick }) {
  const classes = useStyles();

  return (
    <div className={classes.card} style={{ backgroundColor: color }}>
      <div className={classes.row}>
        <>
          <Typography variant="h4">{title}</Typography>
        </>
        <div
          onClick={(e) => {
            e.stopPropagation();
            onClick(type);
          }}
        >
          <InfoIcon />
        </div>

        <Typography variant="subtitle1">{subTitle}</Typography>
      </div>
      <div className={classes.row} style={{ flex: 1 }}>
        <Typography
          variant={type === "change" ? "caption" : "body"}
          className={classes.body}
        >
          {discription}
        </Typography>
        <div className={classes.wrapIcon}>
          <CallMadeIcon />
        </div>
      </div>
    </div>
  );
}

export default function VisaStatusCard() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const isSM = useMediaQuery(theme.breakpoints.up("sm"));
  const { showLoading, hideLoading } = useModalLoading();
  const [isRequesting, setRequesting] = useState(false);
  const [exitingSmart, setExitingSmart] = useState(false);
  const [isModalSmartTVisible, setModalSmartTVisible] = useState(false);
  const [isModalSmartTFormVisible, setModalSmartTFormVisible] = useState(false);
  const [isModalChangeVisible, setModalChangeVisible] = useState(false);
  const [isModalInfoVisible, setModalInfoVisible] = useState(false);
  const [infoType, setInfoType] = useState("");

  const { personalID } = useSelector((state) => state.personal.detail);
  const checkRequestSmartFormState = useSelector(selectCheckRequestSmartForm);
  const smartFormExtensionState = useSelector(selectSmartFormExtension);
  const documentRequiredState = useSelector(selectDocumentRequired);

  const smartserviceName =
    smartFormExtensionState?.data?.smartserviceName ?? "";

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });
  const smartformDetail = get(
    smartFormExtensionState?.data,
    "detail",
    []
  ).reduce(smartNameById, {});
  const conditionType = get(smartformDetail, "ConditionType.value", "");
  const ConditionType =
    smartserviceName === SMART_TYPE.SMART_S
      ? conditionType
      : SMART_NAME_ALIAS[smartserviceName];

  const visaStatusList = [
    {
      title: "SMART VISA Extension",
      subTitle: "",
      discription: "Apply for SMART VISA extension before its expiration here",
      color: theme.palette.primary.main,
      type: "extension",
    },
    {
      title: "SMART VISA Qualifications Update",
      subTitle: "",
      discription:
        "Notify us of the changes to your employment, investment, or company information under SMART VISA (additional employment, change of company address, shareholding structure, job position, adjustment of investment portfolio, etc.)",
      color: theme.palette.warning.main,
      type: "change",
    },
    {
      title: "SMART VISA Status Report",
      subTitle: "",
      discription:
        "Report your status and eligibility for SMART VISA to SMART VISA Unit on a yearly basis here",
      color: theme.palette.secondary.main,
      type: "statusReport",
    },
    {
      title: "SMART VISA Termination",
      // subTitle: "Issurance Appointment",
      subTitle: "",
      discription:
        "Request for an official document to support the termination of your SMART VISA at the Immigration office ",
      color: theme.palette.error.main,
      type: "cancel",
    },
  ];
  console.log(personalID);
  useEffect(async () => {
    console.log(personalID);

    const res = await VisaFormService.checkExistingSmart({ personalID });
    if (res.status && res.results?.draftId) {
      setExitingSmart(true);
    }
  }, []);

  useEffect(() => {
    if (!checkRequestSmartFormState.isLoading) {
      if (checkRequestSmartFormState.isSuccess) {
        hideLoading();
        setModalChangeVisible(true);
        dispatch(checkRequestSmartFormSlice.actions.clearAsyncState());
      } else if (checkRequestSmartFormState.isFailure) {
        dispatch(checkRequestSmartFormSlice.actions.clearAsyncState());
        hideLoading();
      }
    }
  }, [dispatch, hideLoading, checkRequestSmartFormState]);

  useEffect(() => {
    if (!documentRequiredState.isLoading && isRequesting) {
      if (documentRequiredState.isSuccess) {
        hideLoading();
        dispatch(documentRequiredSlice.actions.clearAsyncState());
        setModalSmartTVisible(true);
        setRequesting(false);
      } else if (documentRequiredState.isFailure) {
        dispatch(documentRequiredSlice.actions.clearAsyncState());
        hideLoading();
        setRequesting(false);
      }
    }
  }, [dispatch, hideLoading, documentRequiredState, isRequesting]);

  useEffect(() => {
    if (!smartFormExtensionState.isLoading) {
      if (smartFormExtensionState.isSuccess) {
        dispatch(extensionSlice.actions.clearAsyncState());
        dispatch(
          getDocumentRequired({
            smartserviceId: "ea67ab08-5953-4453-0830-28ed243a8d38",
            ConditionType: ConditionType,
            isUpload: false,
          })
        );
        setRequesting(true);
      } else if (smartFormExtensionState.isFailure) {
        dispatch(extensionSlice.actions.clearAsyncState());
        hideLoading();
      }
    }
  }, [dispatch, hideLoading, history, smartFormExtensionState]);

  const handleSelectType = (type) => {
    if (type === "cancel") {
      dispatch(setStep(CANCEL_STEP.CANCEL_A));

      history.push(`/cancel-visa/${personalID}`);
    }

    if (type === "statusReport") {
      // dispatch(setStep(CANCEL_STEP.CANCEL_A));
      dispatch(setStepStatusReport(STATUS_REPORT_STEP.STATUS_REPORT_STEP_A));

      history.push(`/status-report/${personalID}`);
    }

    if (type === "change") {
      showLoading();
      dispatch(checkRequestSmartForm({ personalId: personalID }));
    }

    if (type === "extension") {
      showLoading();
      dispatch(getExtension({ personalId: personalID }));
    }
  };

  const handleStamrtTModalClose = () => {
    setModalSmartTVisible(false);
    dispatch(documentRequiredSlice.actions.clearAsyncState());
  };
  const handleSubmitInfo = async () => {
    if (smartserviceName === "Smart S") {
      setModalSmartTVisible(false);
      setModalSmartTFormVisible(true);
    } else {
      setModalSmartTVisible(false);
      dispatch(setHomeTab(HOME_TAB.CHECK_STATUS));
      dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
      dispatch(setIsExtension(true));
    }
  };

  const handleSmartTFormClose = () => {
    setModalSmartTFormVisible(false);
  };
  const handleSmartTFormSubmit = () => {
    dispatch(documentRequiredSlice.actions.clearAsyncState());
    setModalSmartTVisible(false);
    setModalSmartTFormVisible(false);

    dispatch(setHomeTab(HOME_TAB.CHECK_STATUS));
    dispatch(setSmartFormStep(SMART_T_STEP.PART_A_1));
    dispatch(setIsExtension(true));
  };

  let RequestForm;
  let RequestInfo;

  switch (smartserviceName) {
    case "Smart T": {
      RequestForm = null;
      RequestInfo = RequestTalentInfo;
      break;
    }
    case "Smart E": {
      RequestForm = null;
      RequestInfo = RequestTalentInfo;
      break;
    }
    case "Smart I": {
      RequestForm = null;
      RequestInfo = RequestTalentInfo;
      break;
    }
    case "Smart O": {
      RequestForm = null;
      RequestInfo = RequestTalentInfo;
      break;
    }
    case "Smart S": {
      RequestForm = RequestStartupTalentForm;
      RequestInfo = RequestTalentInfo;
      break;
    }
    default: {
      break;
    }
  }

  return (
    <div className={classes.root}>
      <Grid
        container
        xs={12}
        spacing={isSM ? 4 : 0}
        style={{ margin: 0, padding: 0 }}
      >
        {exitingSmart && visaStatusList.map((content) => (
            <Grid
              key={content.title}
              xs={12}
              sm={6}
              md={4}
              item
              className={classes.wrapType}
              onClick={() => handleSelectType(content.type)}
            >
              <StatusCard
                {...content}
                onClick={(type) => {
                  setInfoType(type);
                  setModalInfoVisible(true);
                }}
              />
            </Grid>
          ))}
      </Grid>
      <Dialog
        open={isModalSmartTVisible}
        onClose={handleStamrtTModalClose}
        maxWidth="lg"
      >
        <DialogContent>
          <RequestInfo
            onCancel={handleStamrtTModalClose}
            onSubmit={handleSubmitInfo}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={isModalSmartTFormVisible}
        onClose={handleSmartTFormClose}
        maxWidth="lg"
      >
        <DialogContent>
          <RequestForm
            onCancel={handleSmartTFormClose}
            onSubmit={handleSmartTFormSubmit}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={isModalChangeVisible}
        onClose={() => setModalChangeVisible(false)}
        maxWidth="lg"
      >
        <DialogContent>
          <ChangeSelectPart onClose={() => setModalChangeVisible(false)} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={isModalInfoVisible}
        onClose={() => setModalInfoVisible(false)}
        maxWidth="lg"
      >
        <DialogContent>
          <SmartTypeInfo
            type={infoType}
            onClose={() => setModalInfoVisible(false)}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
